<template>
    <v-card>
        <v-card-title
            class="blue-grey lighten-4"
            dark
        >
            <span class="headline font-weight-regular">{{title}}</span>
            <v-btn
                :color="btnRefreshColor"
                dark class="mb-2"
                small
                absolute
                right
                fab
                style="top: 10px; right: 60px;"
                @click="() => { $emit('refresh') }"
            >
                <v-icon>refresh</v-icon>
            </v-btn>
            <v-dialog
                @keydown.esc="() => { $emit('close') }"
                persistent
                :value="value"
                @input="toggleDialog"
                width="50%"
            >
                <v-btn
                    title="Novo"
                    :color="btnAddColor"
                    dark slot="activator"
                    class="mb-2"
                    small
                    absolute
                    right
                    fab
                    style="top: 10px;"
                >
                    <v-icon>add</v-icon>
                </v-btn>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <slot name="form"></slot>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            style="font-weight: bold;"
                            color="pink"
                            flat
                            :disabled="loadingSave"
                            @click.native="() => { $emit('close') }"
                        >Cancelar</v-btn>
                        <v-btn
                            style="font-weight: bold;"
                            color="indigo darken-4"
                            flat
                            :loading="loadingSave"
                            @click.native="() => { $emit('save') }"
                            :disabled="!isValid"
                        >Salvar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-card-text>
            <slot name="table"></slot>
        </v-card-text>
    </v-card>
</template>

<script>

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    formTitle: {
      type: String,
      default: 'Formulário'
    },
    title: {
      type: String,
      required: true
    },
    btnRefreshColor: {
      type: String,
      default: 'green'
    },
    btnAddColor: {
      type: String,
      default: 'pink'
    },
    isValid: {
      type: Boolean,
      required: true
    },
    loadingSave: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleDialog () {
      this.$emit('input', !this.value)
    }
  },
  watch: {
    value (val) {
      if (!val) this.$emit('close')
      else {
        this.$emit('carregarEstrangeiros');
      }
    }
  }
}
</script>

<style scoped>

</style>
